



























import { Component, Vue } from 'vue-property-decorator';

@Component
export default class FirstBlock extends Vue {
  public about = { name: 'about' };
}
